import React from 'react'
import { Builder } from '@builder.io/react'
import classNames from 'classnames'
import { Button } from '../Button'

type CtaButtonProps = {
  text: string;
  link: string;
  isPrimary: boolean;
}

export const CtaButton = ( props: CtaButtonProps ): JSX.Element => {
  const { text, link, isPrimary } = props
  const btnClasses = classNames( `h-11 rounded-[30px] !w-auto !my-0`, {
    'btn-primary': isPrimary,
    'btn-secondary': !isPrimary
  })
  const onClickHandler = () => {
    window.location.href = link
  }

  return (
    <>
      {text && link && (
        <Button className={btnClasses} onClick={onClickHandler}>
          {text}
        </Button>
      )}
    </>
  )
}

Builder.registerComponent( CtaButton, {
  name: `CtaButton`,
  inputs: [
    {
      name: `text`,
      type: `string`,
      required: true,
      defaultValue: `Button`
    },
    {
      name: `link`,
      type: `url`,
      required: true,
      defaultValue: `/`
    },
    {
      name: `isPrimary`,
      type: `boolean`,
      defaultValue: false
    }
  ]
})

export default CtaButton